import { render } from "./expert.vue?vue&type=template&id=31a91526&scoped=true"
import script from "./expert.vue?vue&type=script&lang=js"
export * from "./expert.vue?vue&type=script&lang=js"

import "./expert.vue?vue&type=style&index=0&id=31a91526&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31a91526"

export default script